$(document).ready(function () {
  let activeShop = null;
  let activeWrap = null;

  const $shopPopup = $("#shopPopup");
  const $parentDiv = $("#shops-map-container");
  const $shopPopupClose = $(".shopPopup_close");

  function updateShopLink(baseLink) {
    if (!baseLink) return "";

    let link = baseLink;

    if (document.cookie.includes("PopupHidden=")) {
      link += (link.includes("?") ? "&" : "?") + "locationApproved=true";
    }

    const query = window.location.search;
    const utmParams = query.match(/utm_[^&=]+=[^&]+/gi);

    if (utmParams && utmParams.length > 0) {
      link += (link.includes("?") ? "&" : "?") + utmParams.join("&");
    }

    return link;
  }

  function calculateRelativePosition(child) {
    const parentRect = $parentDiv[0].getBoundingClientRect();
    const childRect = child.getBoundingClientRect();

    return {
      x: childRect.left - parentRect.left,
      y: childRect.top - parentRect.top
    };
  }

  function updatePopupPosition() {
    if (!activeShop) return;

    const wasHidden = $shopPopup.css("display") === "none";

    if (wasHidden) {
      $shopPopup.css({
        display: "flex",
        position: "absolute",
        visibility: "hidden"
      });
    }

    const pos = calculateRelativePosition(activeShop);
    const popupRect = $shopPopup[0].getBoundingClientRect();
    const parentRect = $parentDiv[0].getBoundingClientRect();

    const MARGIN = 15;
    const minLeft = MARGIN;
    const maxLeft = parentRect.width - popupRect.width - MARGIN;
    const minTop = MARGIN;
    const maxTop = parentRect.height - popupRect.height - MARGIN;

    let finalX = Math.min(Math.max(pos.x, minLeft), maxLeft);
    let finalY = Math.min(Math.max(pos.y, minTop), maxTop);

    finalX = Math.round(finalX);
    finalY = Math.round(finalY);

    $shopPopup.css({
      left: finalX + "px",
      top: finalY + "px",
      position: "absolute",
      display: "flex",
      visibility: "visible"
    });
  }

  function showPopup(shopData) {
  shopData.shopLink = updateShopLink(shopData.shopLink);

  const $shopImage = $shopPopup.find("#shopImage");
  const imageEl = $shopImage.get(0);

  $shopPopup.find("#shopName").text(shopData.shopName || "");
  $shopPopup.find("#shopDetails").text(shopData.shopDetails || "");
  $shopPopup.find("#shopImage").attr("src", shopData.shopImage || "");
  $shopPopup.find("#shopLink").attr("href", shopData.shopLink || "#");
  $shopPopup.find("#shopLink .map-shop-popup__link-text").text(shopData.shopLinkText || "");

  updatePopupPosition();

  if (imageEl) {
    imageEl.onload = function () {
      updatePopupPosition();
    };

    if (imageEl.complete) {
      updatePopupPosition();
    }
  }
}

  function hidePopup(keepHover) {
    keepHover = keepHover || false;

    $shopPopup.css("display", "none");

    const $shopImage = $shopPopup.find("#shopImage");
    const imageEl = $shopImage.get(0);

    $shopPopup.find("#shopName").text("");
    $shopPopup.find("#shopDetails").text("");
    $shopPopup.find("#shopLink").attr("href", "#");
    $shopPopup.find("#shopLink .map-shop-popup__link-text").text("");

    $shopImage.attr("src", "");
    $shopImage.attr("alt", "");

    if (imageEl) {
      imageEl.onload = null;
    }

    if (activeWrap && activeWrap.length) {
      activeWrap.find(".map-selector").removeClass("active");
      activeWrap.find(".country-map").removeClass("active");
      activeWrap.find('[id$="_map"]').removeClass("active");

      if (!keepHover) {
        activeWrap.find(".hover").removeClass("hover");
      }
    } else {
      $(".map-selector").removeClass("active");
      $(".country-map").removeClass("active");
      $('#shops-map-container [id$="_map"]').removeClass("active");

      if (!keepHover) {
        $(".hover").removeClass("hover");
      }
    }

    activeShop = null;
    activeWrap = null;
  }

  $(document).on("click", ".map-selector", function () {
    const $el = $(this);
    const $wrap = $el.closest(".map-wrap-svg");
    const id = $el.attr("id") || "";
    const base = id.replace(/_(data|map)$/i, "");

    if (!base || !$wrap.length) return;

    const targetId = base + "_map";
    const dataId = base + "_data";

    const $dataEl = $wrap.find("#" + dataId).first();
    const $mapEl = $wrap.find("#" + targetId).first();
    const newActive = $dataEl.get(0);

    if (!$dataEl.length || !$mapEl.length) return;

    if (activeShop === newActive && $shopPopup.is(":visible")) {
      hidePopup(true);
      return;
    }

    hidePopup(true);

    $wrap.find(".map-selector").removeClass("active");
    $wrap.find(".country-map").removeClass("active");
    $wrap.find('[id$="_map"]').removeClass("active");

    $dataEl.addClass("active");
    $mapEl.addClass("active");

    activeShop = newActive;
    activeWrap = $wrap;

    const shopData = {
      shopName: $dataEl.data("shop-name"),
      shopDetails: $dataEl.data("shop-details"),
      shopImage: $dataEl.data("shop-image"),
      shopLink: $dataEl.data("shop-link"),
      shopLinkText: $dataEl.data("link-title")
    };

    setTimeout(function () {
      showPopup(shopData);
    }, 0);
  });

  $(document).on("click", ".country-map", function () {
    const $el = $(this);
    const $wrap = $el.closest(".map-wrap-svg");
    const id = $el.attr("id") || "";
    const base = id.replace(/_(data|map)$/i, "");

    if (!base || !$wrap.length) return;

    const dataId = base + "_data";
    const targetId = base + "_map";

    const $dataEl = $wrap.find("#" + dataId).first();
    const $mapEl = $wrap.find("#" + targetId).first();
    const newActive = $dataEl.get(0);

    if (!$dataEl.length || !$mapEl.length) return;

    if (activeShop === newActive && $shopPopup.is(":visible")) {
      hidePopup(true);
      return;
    }

    hidePopup(true);

    $wrap.find(".map-selector").removeClass("active");
    $wrap.find(".country-map").removeClass("active");
    $wrap.find('[id$="_map"]').removeClass("active");

    $mapEl.addClass("active");
    $dataEl.addClass("active");

    activeShop = newActive;
    activeWrap = $wrap;

    const shopData = {
      shopName: $dataEl.data("shop-name"),
      shopDetails: $dataEl.data("shop-details"),
      shopImage: $dataEl.data("shop-image"),
      shopLink: $dataEl.data("shop-link"),
      shopLinkText: $dataEl.data("link-title")
    };

    setTimeout(function () {
      showPopup(shopData);
    }, 0);
  });

  $(document).on("click", function (e) {
    if (
      $(e.target).closest(".map-shop-popup").length ||
      $(e.target).closest(".map-selector").length ||
      $(e.target).closest(".country-map").length
    ) {
      return;
    }

    hidePopup(false);
  });

  if ($(window).width() >= 768) {
    $(document).on("mouseenter", ".country-map, .map-selector", function () {
      const $el = $(this);
      const $wrap = $el.closest(".map-wrap-svg");
      const id = $el.attr("id") || "";
      const base = id.replace(/_(data|map)$/i, "");

      if (!base || !$wrap.length) return;

      $wrap.find(".hover").removeClass("hover");
      $wrap.find("#" + base + "_map").addClass("hover");
      $wrap.find("#" + base + "_data").addClass("hover");
    });

    $(document).on("mouseleave", ".country-map, .map-selector", function (e) {
      const $wrap = $(this).closest(".map-wrap-svg");

      if ($(e.relatedTarget).closest(".country-map, .map-selector").length) {
        return;
      }

      if ($wrap.length) {
        $wrap.find(".hover").removeClass("hover");
      }
    });
  }

  $(window).on("resize", updatePopupPosition);

  $shopPopupClose.on("click", function () {
    hidePopup(false);
  });

  $(".shops-map__switcher-button").on("click", function () {
    if ($(this).hasClass("active")) return;

    const map = $(this).attr("data-map");

    $(".shops-map__switcher-button").removeClass("active");
    $(this).addClass("active");

    if (map === "usa") {
      $(".map-mobile-usa").addClass("active");
      $(".map-mobile-europe").removeClass("active");
    } else {
      $(".map-mobile-europe").addClass("active");
      $(".map-mobile-usa").removeClass("active");
    }

    hidePopup(false);
  });
});